<div class="view-wrapper">
  <dx-toolbar class="theme-dependent" [class.scrolled]="isContentScrolled">
    <dxi-item location="before">
      <div class="header-text">Hesabım</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
      <dx-button text="Kapat" icon="close" stylingMode="contained" type="danger" (onClick)="goBack()"></dx-button>
    </dxi-item>
  </dx-toolbar>

  <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
    <div class="hs">
      <!-- Sol: kimlik kartı -->
      <div class="hs-kart hs-kimlik">
        <div class="hs-bant"></div>
        <div class="hs-kimlik-govde">
          <img *ngIf="foto; else harfFoto" class="hs-foto" [src]="foto" alt="Profil fotoğrafı" (error)="foto = null" />
          <ng-template #harfFoto><div class="hs-foto hs-harf">{{ basHarfler }}</div></ng-template>
          <span class="hs-foto-kaynak" *ngIf="foto"><i class="fa-solid fa-id-card-clip"></i>Personel kaydındaki fotoğraf</span>
          <h2>{{ adSoyad }}</h2>
          <div class="hs-kullanici">@{{ userInfo?.kullaniciAd }}</div>
          <div class="hs-rozetler">
            <span class="hs-rozet altin" *ngIf="userInfo?.isAdmin"><i class="fa-solid fa-crown"></i>Yönetici</span>
            <ng-container *ngIf="personel; else personelYokRozet">
              <span class="hs-rozet" *ngIf="personel.gorevBirimAd || personel.kadroBirimAd"><i class="fa-solid fa-building"></i>{{ personel.gorevBirimAd || personel.kadroBirimAd }}</span>
              <span class="hs-rozet gri" *ngIf="personel.personelTurAd"><i class="fa-solid fa-user-tie"></i>{{ personel.personelTurAd }}</span>
            </ng-container>
            <ng-template #personelYokRozet>
              <span class="hs-rozet gri" *ngIf="personelYuklendi"><i class="fa-solid fa-user"></i>Personel kaydı yok</span>
            </ng-template>
          </div>
          <div class="hs-eylemler">
            <button type="button" class="hs-btn ana" (click)="changePassword()"><i class="fa-solid fa-key"></i>Şifremi Değiştir</button>
            <button type="button" class="hs-btn ikinci" *ngIf="foto" (click)="fotografiIndir()"><i class="fa-solid fa-download"></i>Fotoğrafı İndir</button>
            <button type="button" class="hs-btn cikis" (click)="oturumuKapat()"><i class="fa-solid fa-right-from-bracket"></i>Oturumu Kapat</button>
          </div>
        </div>
      </div>

      <ng-template #satir let-etiket="etiket" let-deger="deger" let-kopya="kopya">
        <div class="hs-satir">
          <span class="hs-et">{{ etiket }}</span>
          <span class="hs-dg" [class.yok]="!deger" [title]="deger || ''">{{ deger || 'Girilmemiş' }}</span>
          <button type="button" class="hs-kopya" *ngIf="kopya && deger" title="Kopyala" (click)="copyToClipboard(deger, $event)"><i class="fa-regular fa-copy"></i></button>
        </div>
      </ng-template>

      <!-- Sağ: bölümler (salt okunur) -->
      <div class="hs-sag">
        <div class="hs-kart">
          <div class="hs-bolum-bas"><span class="hs-ik"><i class="fa-solid fa-user-gear"></i></span><h3>Hesap<small>Giriş ve iletişim</small></h3></div>
          <div class="hs-satirlar">
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Kullanıcı adı', deger: userInfo?.kullaniciAd, kopya: true }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Kullanıcı kodu', deger: userInfo?.kullaniciKod?.toString(), kopya: true }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'E-posta', deger: userInfo?.email || personel?.eMail, kopya: true }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Telefon', deger: userInfo?.telefon || personel?.gsmTelefon, kopya: true }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Yetki', deger: userInfo?.isAdmin ? 'Yönetici' : 'Standart kullanıcı' }"></ng-container>
          </div>
        </div>

        <div class="hs-kart">
          <div class="hs-bolum-bas"><span class="hs-ik"><i class="fa-solid fa-sliders"></i></span><h3>Tercihler<small>Bildirim ve görünüm</small></h3></div>
          <div class="hs-satirlar">
            <div class="hs-satir">
              <span class="hs-et">E-posta bildirimi</span>
              <span class="hs-anahtar" [class.acik]="personel?.mailBilgiEh === 'E'"><span class="sw"></span>{{ personel?.mailBilgiEh === 'E' ? 'Açık' : 'Kapalı' }}</span>
            </div>
            <div class="hs-satir">
              <span class="hs-et">SMS bildirimi</span>
              <span class="hs-anahtar" [class.acik]="personel?.smsBilgiEh === 'E'"><span class="sw"></span>{{ personel?.smsBilgiEh === 'E' ? 'Açık' : 'Kapalı' }}</span>
            </div>
            <div class="hs-satir">
              <span class="hs-et">Tema</span>
              <span class="hs-tema"><span class="hs-daire"></span>{{ temaAdi }}</span>
            </div>
          </div>
          <div class="hs-not"><i class="fa-solid fa-circle-info"></i>Bildirim tercihleri personel kaydından okunur; tema sağ üstteki renk dairesinden değişir.</div>
        </div>

        <div class="hs-kart tam" *ngIf="personel">
          <div class="hs-bolum-bas"><span class="hs-ik"><i class="fa-solid fa-id-badge"></i></span><h3>Personel<small>İnsan Kaynakları kaydı</small></h3></div>
          <div class="hs-satirlar iki">
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Sicil no', deger: personel.kurumSicilNo, kopya: true }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Personel türü', deger: personel.personelTurAd }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Kadro birimi', deger: personel.kadroBirimAd }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Görev birimi', deger: personel.gorevBirimAd }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'İşe giriş', deger: (personel.ilkGirisTarih | date: 'dd.MM.yyyy') }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Doğum tarihi', deger: (personel.dogumTarih | date: 'dd.MM.yyyy') }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'TCKN', deger: maskeliTckn }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Dahili', deger: personel.dahiliTelefon, kopya: true }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'Cep telefonu', deger: personel.gsmTelefon, kopya: true }"></ng-container>
            <ng-container *ngTemplateOutlet="satir; context: { etiket: 'KEP adresi', deger: personel.kepPosta, kopya: true }"></ng-container>
          </div>
        </div>
        <div class="hs-kart tam" *ngIf="personelYuklendi && !personel">
          <div class="hs-not genis"><i class="fa-solid fa-circle-info"></i>Bu kullanıcıya bağlı bir personel kaydı bulunmuyor. Personel bilgileri, fotoğraf ve izin işlemleri yalnızca personel kaydı olan kullanıcılarda görünür.</div>
        </div>
      </div>
    </div>
  </dx-scroll-view>
</div>
<ng-container *ngIf="isChangePasswordPopupOpened">
<dk-change-password-popup
  [userInfo]="userInfo"
  [visible]="isChangePasswordPopupOpened"
  (visibleChange)="isChangePasswordPopupOpened = $event"
></dk-change-password-popup>
</ng-container>
